/**
 * Общее для комментариев и блока «Профиль» в ЛК.
 *
 * Аватар ужимается в браузере: центральный квадрат → 128×128 → JPEG.
 * Качество снижаем, пока картинка не влезет в 60 КБ — тот же лимит
 * проверяет сервер (routers/comments.py), так что отказа там не будет.
 */

export const AVATAR_SIDE = 128;
export const AVATAR_MAX_BYTES = 60 * 1024;
export const COMMENT_MAX = 1000;
export const GUEST_NAME = 'Звёздная гостья';

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('bad image')); };
    img.src = url;
  });
}

function dataUrlBytes(dataUrl) {
  const b64 = dataUrl.slice(dataUrl.indexOf(',') + 1);
  return Math.floor((b64.length * 3) / 4);
}

export async function fileToAvatar(file) {
  if (!file || !/^image\//.test(file.type || '')) {
    throw new Error('Выбери картинку: JPG или PNG');
  }
  let img;
  try {
    img = await loadImage(file);
  } catch (_e) {
    throw new Error('Не получилось открыть картинку. Попробуй JPG или PNG');
  }
  const side = Math.min(img.naturalWidth, img.naturalHeight);
  if (!side) throw new Error('Не получилось открыть картинку');
  const sx = Math.floor((img.naturalWidth - side) / 2);
  const sy = Math.floor((img.naturalHeight - side) / 2);

  const canvas = document.createElement('canvas');
  canvas.width = AVATAR_SIDE;
  canvas.height = AVATAR_SIDE;
  const ctx = canvas.getContext('2d');
  // Прозрачный PNG в JPEG станет чёрным — подкладываем белый фон.
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, AVATAR_SIDE, AVATAR_SIDE);
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(img, sx, sy, side, side, 0, 0, AVATAR_SIDE, AVATAR_SIDE);

  for (const q of [0.9, 0.8, 0.7, 0.6, 0.5, 0.4]) {
    const out = canvas.toDataURL('image/jpeg', q);
    if (out.startsWith('data:image/jpeg') && dataUrlBytes(out) <= AVATAR_MAX_BYTES) return out;
  }
  throw new Error('Картинка слишком тяжёлая, выбери другую');
}

/** Подсказка к звёздам: «На сайте N мес.» */
export function tenureHint(months) {
  if (!months || months < 1) return 'На сайте меньше месяца';
  return `На сайте ${months} мес.`;
}

export function formatCommentDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch (_e) {
    return '';
  }
}

/**
 * Страницы-источники комментариев: ключ thread → название и адрес.
 * Ключи — THREADS в backend/routers/comments.py. Лента общая на весь сайт,
 * у комментария подпись «из …» — ссылка сюда.
 */
export const THREAD_META = {
  home: { label: 'Главная', path: '/' },
  natal: { label: 'Натальная карта', path: '/natalnaya-karta' },
  horar: { label: 'Хорар', path: '/horar' },
  day: { label: 'События дня', path: '/transits' },
  month: { label: 'Твой месяц', path: '/events-month' },
  love: { label: 'Любовь и замужество', path: '/love-periods' },
  money_periods: { label: 'Денежные периоды', path: '/money-periods' },
  money: { label: 'Где твои деньги', path: '/money' },
  obraz: { label: 'Как тебя видят', path: '/obraz' },
  num: { label: 'Нумерология', path: '/numerology' },
  uzel: { label: 'Предназначение', path: '/uzel' },
  work: { label: 'Профессия', path: '/work' },
  mum: { label: 'Партнёр', path: '/mum' },
  para: { label: 'Совместимость', path: '/para' },
  women: { label: 'Женские события дня', path: '/women' },
};
